var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPagelocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_recommendPage",
    transform: "translate(-527 -321)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1",
    "data-name": "\\uC0AC\\uAC01\\uD615 1",
    width: 40,
    height: 40,
    rx: 5,
    transform: "translate(527 321)",
    fill: "#f7f8f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_168",
    "data-name": 168,
    transform: "translate(537 331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_110",
    "data-name": "\\uD328\\uC2A4 110",
    d: "M0,0H20V20H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_133",
    "data-name": "\\uC0AC\\uAC01\\uD615 133",
    width: 13.333,
    height: 13.333,
    rx: 2,
    transform: "translate(3.333 3.333)",
    fill: "none",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_8",
    "data-name": "\\uC120 8",
    d: "M0,0H13.333",
    transform: "translate(3.333 7.5)",
    fill: "none",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPagelocation);
export default __webpack_public_path__ + "static/media/icon-pagelocation.d1ba7a40.svg";
export { ForwardRef as ReactComponent };